import { render, staticRenderFns } from "./ItemRef.vue?vue&type=template&id=79ad7f3c&scoped=true&"
import script from "./ItemRef.vue?vue&type=script&lang=js&"
export * from "./ItemRef.vue?vue&type=script&lang=js&"
import style0 from "./ItemRef.vue?vue&type=style&index=0&id=79ad7f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad7f3c",
  null
  
)

export default component.exports